import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';
import { snakify, snakifyKeys } from 'helpers/syntaxHelper';
import { BudgetPhases } from 'business/constants';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';

/** Hook to fetch statuses settings.  */
export const useGetStatusesSettings = (): UseQueryResult<
    StatusesSettingsT | undefined
> =>
    useQuery({
        queryKey: ['statuses_settings'],
        queryFn: async () => {
            const response = await RQAPICall<StatusesSettingsT>({
                endpoint: 'budget/inscription/statuses',
                method: 'GET',
            });

            /**
             * we process the data because phases names and statuses are returned
             * in camelCase, but here we want to keep snake_case for translations
             */
            const statusesSettingsObj = {} as StatusesSettingsT;
            (Object.keys(response.content) as BudgetPhases[]).forEach(
                (phase) =>
                    (statusesSettingsObj[
                        phase === 'voté' ? BudgetPhases.VOTE : snakify(phase)
                    ] = snakifyKeys(response.content[phase]!)),
            );

            return statusesSettingsObj;
        },
        meta: {
            useGlobalOnError: true,
        },
        // five minutes in milliseconds
        staleTime: 5 * 60 * 1000,
    });
